// extracted by mini-css-extract-plugin
export default {"wrapper":"ClientsTableActions_wrapper__EhbjM"};